import { Input } from "@mui/icons-material"
import { Button } from "@mui/material"
import { DetailedHTMLProps, InputHTMLAttributes } from "react"

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

type FileUploadButtonInputProps = InputProps & {
  label: string
}

const FileUploadButtonInput = ({ label, ...props }: FileUploadButtonInputProps) => {
  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<Input />}
      sx={{ borderRadius: 0 }}
    >
      {label}
      <input
        type="file"
        style={{
          clip: "rect(0 0 0 0)",
          clipPath: "inset(50%)",
          height: 1,
          width: 1,
          overflow: "hidden",
          position: "absolute",
          whiteSpace: "nowrap",
          bottom: 0,
          left: 0,
        }}
        {...props}
      />
    </Button>
  )
}

export default FileUploadButtonInput
